import { connect } from 'react-redux';
import SortDropdown from './sortDropdown';
import { onSortSelect } from './sortDropdownActions';

const mapStateToProps = state => ({
  sortFields: state.products.sortFields || [],
  isFetching: state.isFetching,
  selectedSort: state.selectedSort,
});

const mapDispatch = {
  onSortSelect,
};

export default connect(
  mapStateToProps,
  mapDispatch
)(SortDropdown);
